<template>
  <div>
    <v-row class="detail-wrapper" :class="titleBackColor">
      <v-col cols="12" class="px-6 py-0">
        <!-- 현황 타이틀  -->
        <sta-title v-on:setSearchParam="doSearch"></sta-title>
        <!-- 현황 카드 -->
        <holiday-sta-card v-bind:gntGubunCd="gntGubunCd"></holiday-sta-card>
      </v-col>
    </v-row>

    <v-row class="title-wrap">
      <v-col cols="12" class="detail-title d-flex justify-space-between"
        >휴가신청 및 사용
      </v-col>
    </v-row>
    <!-- 휴가현황 리스트 -->
    <holiday-sta-list
      v-bind:searchParam="searchParam"
      v-bind:gntGubunCd="gntGubunCd"
    ></holiday-sta-list>
  </div>
</template>

<script>
/* 휴가현황 */
import StaTitle from '@/components/status/StaTitle.vue';
import HolidayStaCard from '@/components/status/HolidayStaCard.vue';
import HolidayStaList from '@/components/status/HolidayStaList.vue';
import routerConstants from '@/const/routerConstants';

export default {
  data: () => ({
    searchParam: {}, // 조회파라미터
    gntGubunCd: '', // 근태구분코드
    titleBackColor: '',
  }),
  methods: {
    /* 상세항목 세팅 */
    doSearch(param) {
      switch (this.$route.name) {
        case routerConstants.AnnualHolidaySta:
          this.gntGubunCd = '1';
          this.titleBackColor = 'annual-leave';
          break;
        case routerConstants.MaternityHolidaySta:
          this.gntGubunCd = '41';
          this.titleBackColor = 'maternity-leave';
          break;
      }
      this.searchParam = param;
    },
  },
  created() {
    // 스피너 ON
    const colorType =
      this.$route.name === routerConstants.MaternityHolidaySta ? 'pink' : '';
    this.$store.commit('SPINNER/ON_COMMON_SPINNER', colorType);
  },
  components: {
    StaTitle,
    HolidayStaCard,
    HolidayStaList,
  },
};
</script>

<style>
/* detailPage.scss 참고 */
.detail-wrapper.annual-leave {
  background-image: url('../../../assets/img/bg_detail_annualLeave.png');
}
.detail-wrapper.maternity-leave {
  background-image: url('../../../assets/img/bg_detail_maternityLeave.png');
}
</style>
